import { ReactNode } from 'react';
import Footer from '../Footer';
import Breadcrumbs from './Breadcrumbs';
import './PageLayout.css';

type PageLayoutProps = {
  children: ReactNode;
  title?: string;
  showBreadcrumbs?: boolean;
};

export default function PageLayout({ children, title, showBreadcrumbs = true }: PageLayoutProps) {
  return (
    <div className="page">
      <header className="page-header">
        <div className="container page-header-inner">
          <a href="/" className="page-brand" aria-label="На главную">
            <img src="/logo.svg" alt="Recvisit" className="page-brand-logo" />
          </a>
          <nav className="page-nav" aria-label="Навигация">
            <a className="page-nav-link" href="/system-requirements">Требования</a>
            <a className="page-nav-link" href="/faq">FAQ</a>
            <a className="page-nav-link" href="/contacts">Контакты</a>
          </nav>
        </div>
      </header>

      <main className="page-main">
        <div className="container">
          {showBreadcrumbs && <Breadcrumbs />}
          {title && <h1 className="page-title">{title}</h1>}
        </div>
        {children}
      </main>

      <Footer />
    </div>
  );
}

